import { Injectable, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { Header } from './header.interface';
import { Footer } from './footer.interface';
import { DataEntry } from '../shared/data-entry.interface';

@Injectable({ providedIn: "root" })
export class CommonService {

  /* header */
  paramsHeaderChanged = new Subject<Header>();
  private title: string;
  private subtitle: string;
  private showSubtitle: boolean = false;
  private showSubtitleInfo: boolean = false;
  private subtitleInfo: string;
  private question: string;
  private activePage: string;
  private centerContent: boolean;
  private showAddonTitle: boolean;
  private addonTitle: string;
  public showLoader: boolean = false;
  public showFooter: boolean = true;
  public showHeaderPage: boolean = true;
  public showSummaryLoader: boolean = true;

  /* footer */
  paramsFooterChanged = new Subject<Footer>();
  private nextBtnEnabled: boolean = false;
  private nextBtnVisible: boolean = false;
  private backBtnVisible: boolean = false;
  private nextPage: string = "";
  private sendBtnVisible: boolean = false;
  private sendInstallerBtnVisible: boolean = false;
  private customClass: string = null;
  private backHomeBtnVisible: boolean = false;
  private sendBtnEnabled: boolean = false;
  private sendInstallerBtnEnabled: boolean = false;
  private footerTooltip: string = null;

  /* transition */
  private nextPageTransition: string;

  /* analytics */
  private eventCategory: string;
  private eventLabel: string;
  private eventAction: any;
  private eventTranslateAction: boolean;

  private eventV2_Title: string;
  private eventV2_OtherInfo: [{ key: string, value: number }] = null;

  private isSafari: boolean;

  setParams(
    a: string,          //title
    b: string,          //subtitle
    c: string,          //question
    d: string,          //activePage
    e: string,          //nextPage
    f: boolean,         //nextBtnEnabled
    g: boolean,         //nextBtnVisible
    h: boolean,         //sendBtnVisible
    i: boolean,         //centerContent
    j: string = '',     //customClass
    k: boolean = false, //backHomeBtnVisible
    l: boolean = false, //showAddonTitle
    m: string = '',     //eventCategory
    n: string = '',     //eventLabel
    o: boolean = false, //sendBtnEnabled
    p: string = '',     //footerTooltip
    q: boolean = true,  //backBtnVisible
    r: boolean = false, //showSubtitle
    s: boolean = false, //showSubtitleInfo
    t: string = '',     //addonTitle
    u: string = '',     //subtitleInfo
    v: boolean = false  //sendInstallerBtnVisible
  ) {
    this.title = a;

    this.showSubtitle = r;
    this.subtitle = b;

    this.showSubtitleInfo = s;
    this.subtitleInfo = u;

    this.question = c;
    this.activePage = d;
    this.centerContent = i;
    this.showAddonTitle = l;
    this.addonTitle = t;
    this.paramsHeaderChanged.next(this.getHeaderParams());

    this.nextBtnEnabled = f;
    this.nextBtnVisible = g;
    this.backBtnVisible = q;
    this.nextPage = e;
    this.sendBtnVisible = h;
    this.customClass = j;
    this.backHomeBtnVisible = k;
    this.sendBtnEnabled = o;
    this.footerTooltip = p;
    this.paramsFooterChanged.next(this.getFooterParams());

    this.eventCategory = m;
    this.eventLabel = n;
    this.sendInstallerBtnVisible = v;
    this.sendInstallerBtnEnabled = false;
  }

  setFooterParams(
    btnEnabled: boolean,
    btnVisible: boolean,
    backBtnVisible: boolean,
    page: string,
    sendVisible: boolean,
    customClass: string,
    backHomeVisible: boolean,
    tooltip: string = null,
    sendInstallerVisible: boolean
  ) {
    this.nextBtnEnabled = btnEnabled;
    this.nextBtnVisible = btnVisible;
    this.backBtnVisible = backBtnVisible;
    this.nextPage = page;
    this.sendBtnVisible = sendVisible;
    this.customClass = customClass;
    this.backHomeBtnVisible = backHomeVisible;
    this.paramsFooterChanged.next(this.getFooterParams());
    this.footerTooltip = tooltip;
    this.sendInstallerBtnVisible= sendInstallerVisible;
  }

  updateNextPage(n: string) {
    this.nextPage = n;
    this.paramsFooterChanged.next(this.getFooterParams());
  }

  public changeLoaderStatus(value: boolean) {
    this.showLoader = value;
  }

  public changeSummaryLoaderStatus(value: boolean) {
    this.showSummaryLoader = value;
  }

  updateNextBtn(value: boolean) {
    this.nextBtnEnabled = value;
    this.paramsFooterChanged.next(this.getFooterParams());
  }

  updateSendBtn(value: boolean) {
    this.sendBtnEnabled = value;
    this.paramsFooterChanged.next(this.getFooterParams());
  }
  updateSendInstallerBtn(value: boolean) {
    this.sendInstallerBtnEnabled = value;
    this.paramsFooterChanged.next(this.getFooterParams());
  }

  getHeaderParams() {
    return {
      title: this.title,
      subtitle: this.subtitle,
      showSubtitle: this.showSubtitle,
      showSubtitleInfo: this.showSubtitleInfo,
      subtitleInfo: this.subtitleInfo,
      question: this.question,
      activePage: this.activePage,
      centerContent: this.centerContent,
      showAddonTitle: this.showAddonTitle,
      addonTitle: this.addonTitle,
    };
  }

  getFooterParams() {
    return {
      nextBtnEnabled: this.nextBtnEnabled,
      nextBtnVisible: this.nextBtnVisible,
      backBtnVisible: this.backBtnVisible,
      nextPage: this.nextPage,
      sendBtnVisible: this.sendBtnVisible,
      customClass: this.customClass,
      backHomeBtnVisible: this.backHomeBtnVisible,
      sendBtnEnabled: this.sendBtnEnabled,
      tooltip: this.footerTooltip,
      sendInstallerBtnVisible: this.sendInstallerBtnVisible,
      sendInstallerBtnEnabled: this.sendInstallerBtnEnabled,
    };
  }

  setEventAction(valueAction: {}, translate: boolean = false) {
    this.eventAction = valueAction;
    this.eventTranslateAction = translate;
  }

  setLabelEvent(v: string) {
    this.eventLabel = v;
  }

  setCategoryEvent(v: string) {
    this.eventCategory = v;
  }

  getEventParams() {
    return {
      category: this.eventCategory,
      label: this.eventLabel,
      action: this.eventAction,
      translate: this.eventTranslateAction
    };
  }

  setNextPageTransition(next: string) {
    this.nextPageTransition = next;
  }

  getNextPageTransition(): string {
    return this.nextPageTransition;
  }

  setLocationIdentifier() {
    const locationHash = window.location.hash;
    if (locationHash) {
      const hashSplitted = locationHash.split("/");
      if (hashSplitted.length > 1) {
        return "_" + hashSplitted.pop();
      }
    }
  }

  private setIsSafari() {
    let is_chrome = navigator.userAgent.indexOf("Chrome") > -1;
    let is_safari = navigator.userAgent.indexOf("Safari") > -1;
    if (is_safari && !is_chrome) {
      this.isSafari = true;
    }
  }

  getIsSafari() {
    if (this.isSafari == null || this.isSafari == undefined) {
      this.setIsSafari();
    }
    return this.isSafari;
  }

  setGASelectionEvent(eventTitle: string, otherInfo: [{ key: string, value: number }] = null) {
    this.eventV2_Title=eventTitle;
    this.eventV2_OtherInfo=otherInfo;
  }
  getGAEvent_Title(){
    return this.eventV2_Title;
  }
  getGAEvent_OtherInfo(){
    return this.eventV2_OtherInfo;
  }

  getOtherInfoFromSelector(dataEntries: DataEntry[], idSelected: number, prefix: string) {
    let listChooise: [{ key: string; value: number; }];
    dataEntries.forEach(de => {
      let key =  prefix + de.name;
      let value = 0;
      if (de.ID == idSelected)
        value = 1;
      if (listChooise == undefined)
        listChooise = [{ key: key, value: value }];
      else
        listChooise.push({ key: key, value: value });
    });
    return listChooise;
  }
}
